<template>
  <div class="my-2">
    <label class="relative inline-flex cursor-pointer items-center">
      <label class="relative inline-block h-7 w-14">
        <input
          v-model="isCheckedLocal"
          type="checkbox"
          class="peer hidden"
          :value="isCheckedLocal"
          :data-ph-capture-attribute-field-name="testId || undefined"
          :data-ph-capture-attribute-label="label"
          :data-testid="testId + '_state'"
          :disabled="isDisabled"
        />
        <div
          class="h-full w-full rounded-full transition-colors"
          :class="{
            'peer-checked:bg-primary-2 dark:peer-checked:bg-primary-2 bg-gray-200 dark:bg-dark-3':
              !isDisabled,
            'peer-checked:bg-disabled-background dark:peer-checked:bg-dark-disabled-background bg-gray-200 dark:bg-dark-3':
              isDisabled,
          }"
        ></div>
        <div
          class="pointer-events-none absolute left-[4px] top-0.5 h-6 w-6 rounded-full border border-gray-300 bg-white transition-transform peer-checked:translate-x-7 peer-checked:border-white dark:border-gray-600"
        ></div>
      </label>
      <span
        class="ml-3 text-sm text-gray-600 dark:text-gray-300"
        :class="{
          'text-dark-disabled-text dark:text-neutral-400': isDisabled,
        }"
        :data-testid="testId"
        >{{ label }}</span
      >
    </label>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  label: string;
  isChecked: boolean;
  isInverted?: boolean;
  testId?: string;
  isDisabled?: boolean;
}>();
const emit = defineEmits(['update:isChecked', 'isToggled']);

const isCheckedLocal = computed({
  get() {
    if (props.isInverted) {
      return !props.isChecked;
    }
    return props.isChecked;
  },
  set(value) {
    let isChecked = value;
    if (props.isInverted) {
      isChecked = !isChecked;
    }
    emit('update:isChecked', isChecked);
    emit('isToggled', isChecked);
  },
});
</script>
